import { stockQuantitiesChanged } from '../../../utils/stockQuantities';
import { cleanManufacturerUrl } from '../../../utils/manufacturerUrl';
import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Gallery from 'react-photo-gallery';
import DragPhoto from '../../DragPhoto';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import { PRODUCT_STATES } from './constants';
import { parseExchangeRate, convertPoundsToUah } from '../../../utils/productPrice';

const ProductEditModal = ({
  modalId = '#productModal',
  selectedProduct,
  saving = false,
  setSelectedProduct,
  categories,
  discountCategories = [],
  innerProducts,
  isInnerProductAdding,
  alertType,
  alertMessage,
  quantityUpdateAlert,
  parseImageUrl,
  inputRefs,
  setRef,
  handleClick,
  onAddProduct,
  onUpdateProduct,
  onClose,
  onUploadImages,
  removeImage,
  onParseImageUrlChange,
  callParseImagesApi,
  onSortEnd,
  editInnerProduct,
  onDeleteInnerProduct,
  nullableState,
  returnToParent,
  addInnerProduct,
  currencyRates = {},
  onOpenStockHistory
}) => {
  const packFieldsId = `${modalId.replace('#', '')}-pack-fields`;
  const [showPackFields, setShowPackFields] = useState(false);
  useEffect(() => { setShowPackFields(false); }, [selectedProduct.id]);
  useEffect(() => {
    const modal = $(modalId);
    const resetPackFields = () => setShowPackFields(false);
    modal.on('hidden.bs.modal', resetPackFields);
    return () => { modal.off('hidden.bs.modal', resetPackFields); };
  }, [modalId]);
  const poundRate = parseExchangeRate(currencyRates.pound_rate);
  const dollarRate = parseExchangeRate(currencyRates.dollar_rate);
  const euroRate = parseExchangeRate(currencyRates.euro_rate);
  const isNewProduct = selectedProduct.id === '' || selectedProduct.id == null;

  const handlePriceInPoundsChange = (e) => {
    const val = e.target.value;
    const updates = { ...selectedProduct, priceInPounds: val };
    const num = parseFloat(val);
    if (!isNaN(num) && num >= 0 && poundRate != null) {
      updates.price = String(convertPoundsToUah(num, poundRate));
    }
    setSelectedProduct(updates);
  };

  const handlePriceInUSDChange = (e) => {
    const val = e.target.value;
    const updates = { ...selectedProduct, priceInUSD: val };
    const num = parseFloat(val);
    if (!isNaN(num) && num >= 0 && dollarRate != null && dollarRate > 0) {
      updates.price = String(Math.ceil(num * dollarRate));
    }
    setSelectedProduct(updates);
  };

  const handlePriceInEuroChange = (e) => {
    const val = e.target.value;
    const updates = { ...selectedProduct, priceInEuro: val };
    const num = parseFloat(val);
    if (!isNaN(num) && num >= 0 && euroRate != null && euroRate > 0) {
      updates.price = String(Math.ceil(num * euroRate));
    }
    setSelectedProduct(updates);
  };

  const SortablePhoto = SortableElement(item => <DragPhoto item={item} onRemoveItem={removeImage} />);
  const SortableGallery = SortableContainer(({ items }) => (
    <Gallery photos={items} renderImage={props => <SortablePhoto {...props} />} />
  ));

  const renderAlert = () => {
    if (alertType === 'success-add') {
      return (
        <div className="alert alert-success text-center" role="alert">
          Продукт було успішно додано!
        </div>
      );
    }
    if (alertType === 'success-update') {
      return (
        <div className="alert alert-primary text-center" role="alert">
          Продукт було успішно оновлено!
        </div>
      );
    }
    if (alertType === 'alert-danger' && alertMessage) {
      return (
        <div className="alert alert-danger text-center font-weight-bold" role="alert">
          {alertMessage}
        </div>
      );
    }
    return null;
  };

  const renderActionButton = () => {
    if (!isNewProduct) {
      return (
        <button type="submit" className="btn btn-primary" disabled={saving} onClick={e => onUpdateProduct(e)}>
          Оновити продукт
        </button>
      );
    }
    return (
      <button type="submit" className="btn btn-success" disabled={saving} onClick={e => onAddProduct(e)}>
        Додати продукт
      </button>
    );
  };

  const manufacturerUrl = selectedProduct.manufacturerUrl || '';
  const manufacturerHref = (() => {
    const raw = String(manufacturerUrl).trim();
    if (!raw) return '';
    return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  })();

  return (
    <div className="modal fade" tabIndex="-1" role="dialog" id={modalId.replace('#', '')}>
      <form>
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Додавання/перегляд товару</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-6">
                  <label htmlFor="name">Назва</label>
                  <input
                    value={selectedProduct.name}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    className="form-control"
                    type="text"
                    name="name"
                    placeholder="Назва товару"
                    required
                  />
                </div>
                <div className="col">
                  <label htmlFor="quantity">Ціна за одиницю</label>
                  <input
                    className="form-control"
                    type="text"
                    name="price"
                    placeholder="Ціна за шт."
                    value={selectedProduct.price}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    required
                  />
                </div>
                <div className="col">
                  <label htmlFor="quantity">Кількість, шт.</label>
                  <input
                    className="form-control"
                    type="text"
                    name="quantity"
                    placeholder="Кількість одиниць"
                    value={selectedProduct.quantity}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    required
                  />
                </div>
                <div className="col">
                  <label htmlFor="discount">Знижка, %</label>
                  <input
                    className="form-control"
                    type="text"
                    name="discount"
                    placeholder="Знижка на товар"
                    value={selectedProduct.discount}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    required
                  />
                </div>
              </div>

              {!isNewProduct && stockQuantitiesChanged(selectedProduct) && (
                <div className="row pt-2">
                  <div className="col">
                    <label htmlFor="quantityChangeReason" className="font-weight-bold">
                      Причина зміни кількості <span className="text-danger" aria-hidden="true">*</span>
                    </label>
                    <textarea
                      id="quantityChangeReason"
                      className={`form-control quantity-change-reason ${selectedProduct.quantityChangeReason?.trim() ? 'border-success' : 'border-danger'}`}
                      value={selectedProduct.quantityChangeReason || ''}
                      onChange={e => setSelectedProduct({ ...selectedProduct, quantityChangeReason: e.target.value })}
                      placeholder="Наприклад: інвентаризація, списання пошкодженого товару"
                      rows={2}
                      required
                      aria-required="true"
                      aria-invalid={!selectedProduct.quantityChangeReason?.trim()}
                      aria-describedby="quantityChangeReasonHint"
                    />
                    <small id="quantityChangeReasonHint" className="text-danger d-block mt-1">
                      Обов’язково вкажіть причину, щоб зберегти зміну кількості та записати її в аудит.
                    </small>
                  </div>
                </div>
              )}

              {showPackFields && <div className="row pt-1" id={packFieldsId}>
                <div className="col-6">
                  <label htmlFor="packBarcode">Штрихкод пачки</label>
                  <input id="packBarcode" name="packBarcode" type="text" maxLength={80}
                    className="form-control" value={selectedProduct.packBarcode || ''}
                    onChange={e => setSelectedProduct({ ...selectedProduct, packBarcode: e.target.value })} />
                </div>
                <div className="col-6">
                  <label htmlFor="packQuantity">Кількість у пачці, шт.</label>
                  <input id="packQuantity" name="packQuantity" type="number" min="2" step="1" max="2147483647"
                    className="form-control" value={selectedProduct.packQuantity ?? ''}
                    onChange={e => setSelectedProduct({ ...selectedProduct, packQuantity: e.target.value })} />
                </div>
                <div className="col-12"><small className="text-muted">Заповніть обидва поля або залиште обидва порожніми. Скан пачки в поставці додає вказану кількість штук.</small></div>
              </div>}
              <div className="row pt-1">
                <div className="col-3">
                  <label htmlFor="productCode">Артикул</label>
                  <input
                    value={selectedProduct.productCode}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    className="form-control"
                    type="text"
                    name="productCode"
                    placeholder="Артикул"
                    required
                  />
                </div>
                <div className="col-3">
                  <label htmlFor="barcode">Штрих код</label>
                  <div className="input-group">
                    <input
                      id="barcode"
                      value={selectedProduct.barcode || ''}
                      onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                      className="form-control"
                      type="text"
                      name="barcode"
                      placeholder="Штрих код"
                    />
                    <div className="input-group-append">
                      <button type="button" className={`btn btn-sm btn-outline-secondary${showPackFields ? ' active' : ''}`}
                        title={showPackFields ? 'Сховати поля пачки' : 'Показати поля пачки'}
                        aria-label={showPackFields ? 'Сховати поля пачки' : 'Показати поля пачки'}
                        aria-expanded={showPackFields}
                        aria-controls={packFieldsId}
                        onClick={() => setShowPackFields(value => !value)}>
                        <i className="bi bi-box-seam" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-2">
                  <label htmlFor="purchasePrice">Ціна покупки</label>
                  <input
                    className="form-control"
                    type="text"
                    name="purchasePrice"
                    placeholder="Ціна покупки"
                    value={selectedProduct.purchasePrice}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    required
                  />
                </div>
                <div className="col-1">
                  <label htmlFor="priceInUSD">Ціна в $</label>
                  <input
                    value={selectedProduct.priceInUSD}
                    onChange={handlePriceInUSDChange}
                    className="form-control"
                    type="text"
                    name="priceInUSD"
                    placeholder="Ціна в доларах"
                    required
                  />
                </div>
                <div className="col-1">
                  <label htmlFor="priceInPounds">Ціна в £</label>
                  <input
                    value={selectedProduct.priceInPounds}
                    onChange={handlePriceInPoundsChange}
                    className="form-control"
                    type="text"
                    name="priceInPounds"
                    placeholder="Ціна в фунтах"
                    required
                  />
                </div>
                <div className="col-1">
                  <label htmlFor="priceInEuro">Ціна в €</label>
                  <input
                    value={selectedProduct.priceInEuro}
                    onChange={handlePriceInEuroChange}
                    className="form-control"
                    type="text"
                    name="priceInEuro"
                    placeholder="Ціна в євро"
                  />
                </div>
              </div>

              <div className="row pt-2 align-items-end">
                <div className="col-3">
                  <label htmlFor="productState">Статус</label>
                  <select
                    id="productState"
                    className="form-control"
                    value={selectedProduct.state ?? ''}
                    onChange={e => setSelectedProduct({ ...selectedProduct, state: e.target.value })}
                  >
                    <option value="">Оберіть статус</option>
                    {PRODUCT_STATES.filter(s => s.value !== '').map(s => (
                      <option key={s.value} value={s.value}>{s.label}</option>
                    ))}
                  </select>
                </div>
                <div className="col-3">
                  <label htmlFor="discountCategoryName">Категорія знижки</label>
                  <select
                    id="discountCategoryName"
                    className="form-control"
                    value={selectedProduct.discountCategoryName ?? ''}
                    onChange={e => setSelectedProduct({ ...selectedProduct, discountCategoryName: e.target.value || '' })}
                  >
                    <option value="">—</option>
                    {discountCategories.map(name => (
                      <option key={name} value={name}>{name}</option>
                    ))}
                  </select>
                </div>
                <div className="col-3">
                  <label htmlFor="expectedArrivalDate">Прогнозована дата надходження</label>
                  <div className="d-flex align-items-center" style={{ gap: '0.5rem' }}>
                    <input
                      id="expectedArrivalDate"
                      className="form-control"
                      type="date"
                      name="expectedArrivalDate"
                      value={selectedProduct.expectedArrivalDate || ''}
                      onChange={e => setSelectedProduct({ ...selectedProduct, expectedArrivalDate: e.target.value || '' })}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => setSelectedProduct({ ...selectedProduct, expectedArrivalDate: '' })}
                      title="Очистити дату"
                    >
                      Очистити
                    </button>
                  </div>
                </div>
              </div>

              <div className="row pt-2 align-items-end">
                <div className="col-8">
                  <label htmlFor="manufacturerUrl">Посилання на товар</label>
                  <div className="input-group">
                    <input
                      id="manufacturerUrl"
                      className="form-control"
                      type="text"
                      name="manufacturerUrl"
                      placeholder="https://… посилання на сайті виробника"
                      value={manufacturerUrl}
                      onChange={e => setSelectedProduct({ ...selectedProduct, manufacturerUrl: cleanManufacturerUrl(e.target.value) })}
                    />
                    {manufacturerHref ? (
                      <div className="input-group-append">
                        <a
                          className="btn btn-outline-secondary"
                          href={manufacturerHref}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Відкрити посилання"
                        >
                          <i className="bi bi-box-arrow-up-right" />
                        </a>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="col-4 text-right">
                  <label className="d-block">&nbsp;</label>
                  <button type="button" className="btn btn-secondary mr-2" data-dismiss="modal" onClick={onClose}>
                    Закрити
                  </button>
                  {renderActionButton()}
                </div>
              </div>
              <div className="w-100 mt-2">{renderAlert()}</div>

              {quantityUpdateAlert !== undefined && quantityUpdateAlert !== '' ? (
                <div className="alert alert-success text-center mt-2" role="alert">
                  {quantityUpdateAlert}
                </div>
              ) : null}

              <div className="row py-2">
                <div className="col">
                  <label htmlFor="description">Комплектація</label>
                  <textarea
                    className="form-control"
                    name="description"
                    placeholder="Введіть повну комплектацію товару"
                    value={selectedProduct.description}
                    onChange={e => setSelectedProduct({ ...selectedProduct, [e.target.name]: e.target.value })}
                    rows={10}
                    required
                  />
                </div>
              </div>

              <div className="row pt-2">
                <div className="col">
                  <label>Категорії:</label>
                </div>
              </div>
              <div className="row py-2">
                {categories.map(category => (
                  <div key={category.id} className="list-group col-3">
                    <div>
                      <input
                        type="checkbox"
                        name="categoryCheckbox"
                        id={category.id}
                        ref={setRef}
                        checked={selectedProduct.categoryIds.includes(category.id)}
                        onChange={() => handleClick(category.id)}
                      />
                      <label
                        className="list-group-item d-block text-truncate"
                        style={{
                          fontSize: '0.8rem',
                          minHeight: '34px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          ...(!category.parentId ? { borderLeft: '4px solid #007bff' } : {})
                        }}
                        htmlFor={category.id}
                        title={category.name}
                      >
                        {category.name}
                      </label>
                    </div>
                  </div>
                ))}
              </div>

              <div className="row pt-2">
                <div className="col">
                  <label>Зображення:</label>
                </div>
              </div>

              {selectedProduct.id ? (
                <>
                  <SortableGallery items={selectedProduct.images} onSortEnd={onSortEnd} axis="xy" />

                  <div className="row pt-2">
                    <div className="col">
                      <input
                        type="file"
                        className="form-control"
                        multiple
                        onChange={event => onUploadImages(event)}
                      />
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col">
                      <input
                        type="text"
                        className="form-control"
                        value={parseImageUrl}
                        onChange={onParseImageUrlChange}
                        placeholder="Посилання для парсингу картинок"
                      />
                    </div>
                    <div className="col">
                      <button className="btn btn-primary" onClick={e => callParseImagesApi(e)}>
                        Спарсити
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <p className="text-muted small">Спочатку збережіть товар, щоб додати зображення</p>
              )}

              {selectedProduct.parentId === null && !isInnerProductAdding ? (
                <div>
                  <div className="row pt-4">
                    <div className="col">
                      <h3>Внутрішні продукти:</h3>
                    </div>
                  </div>

                  <div className="row pt-2">
                    <div className="col">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col" style={{ width: '6%', whiteSpace: 'nowrap' }}>Id</th>
                            <th scope="col" style={{ width: '54%' }}>Назва</th>
                            <th scope="col" style={{ width: '10%', whiteSpace: 'nowrap' }}>Ціна</th>
                            <th scope="col" style={{ width: '10%', whiteSpace: 'nowrap' }}>Кількість</th>
                            <th scope="col" style={{ width: '10%', whiteSpace: 'nowrap' }}>Дії</th>
                          </tr>
                        </thead>
                        <tbody>
                          {innerProducts.map(innerProduct => (
                            <tr key={innerProduct.id}>
                              <th scope="row">{innerProduct.id}</th>
                              <td>{innerProduct.name}</td>
                              <td>{innerProduct.price}</td>
                              <td>{innerProduct.quantity}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm"
                                  onClick={() => editInnerProduct(innerProduct)}
                                  title="Редагувати"
                                  style={{ padding: '2px 4px', color: '#007bff' }}
                                >
                                  <i className="bi bi-pencil-fill text-dark" style={{ fontSize: '1.125rem' }}></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-link btn-sm"
                                  data-toggle="modal"
                                  data-target="#confirmDeleteModal"
                                  onClick={() => onDeleteInnerProduct(innerProduct)}
                                  title="Видалити"
                                  style={{ padding: '2px 4px', color: '#dc3545' }}
                                >
                                  <i className="bi bi-trash" style={{ fontSize: '1.125rem' }}></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <button className="btn btn-success mr-auto" onClick={addInnerProduct}>
                        Додати внутрішній продукт
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div />
              )}
            </div>
            <div className="modal-footer">
              {selectedProduct.parentId !== null ? (
                <button
                  type="button"
                  className="btn btn-primary mr-auto"
                  onClick={() => returnToParent(selectedProduct.parentId)}
                >
                  Повернутись назад
                </button>
              ) : (
                <div />
              )}
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={onClose}>
                Закрити
              </button>
              {!isNewProduct && typeof onOpenStockHistory === 'function' && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => onOpenStockHistory(selectedProduct)}
                >
                  Історія залишків
                </button>
              )}
              {renderActionButton()}
              <div className="w-100 mt-2">{renderAlert()}</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductEditModal;
